import { Dispatch, MouseEvent, SetStateAction } from 'react';
import { resizeData } from '../types';

type PositionParams = {
  t: number;
  setT: Dispatch<SetStateAction<number>>;
  l: number;
  setL: Dispatch<SetStateAction<number>>;
  w: number;
  setW: Dispatch<SetStateAction<number>>;
  h: number;
  setH: Dispatch<SetStateAction<number>>;
  startT: number | undefined;
  setStartT: Dispatch<SetStateAction<number | undefined>>;
  startL: number | undefined;
  setStartL: Dispatch<SetStateAction<number | undefined>>;
  resizeH: resizeData | undefined;
  setResizeH: Dispatch<SetStateAction<resizeData | undefined>>;
  resizeW: resizeData | undefined;
  setResizeW: Dispatch<SetStateAction<resizeData | undefined>>;
  minWidth: number;
  minHeight: number;
  resetResize: () => void;
  resetMovement: () => void;
};

export const resizeAndMovementFunctions = ({
  t,
  setT,
  l,
  setL,
  w,
  setW,
  h,
  setH,
  startT,
  setStartT,
  startL,
  setStartL,
  resizeH,
  setResizeH,
  resizeW,
  setResizeW,
  minWidth,
  minHeight,
  resetResize,
  resetMovement,
}: PositionParams) => {
  const resolveMovement = (event: MouseEvent<HTMLElement>) => {
    if (!startT) return;
    if (!startL) return;

    setT(t + event.clientY - startT);
    setL(l + event.clientX - startL);

    setStartT(event.clientY);
    setStartL(event.clientX);
  };

  const resolveResizeW = (event: MouseEvent<HTMLElement>) => {
    if (!resizeW) return;

    if (resizeW.direction === 1) {
      const wNew = w + event.clientX - resizeW.movement;
      if (wNew <= minWidth) {
        resetResize();
        resetMovement();
        return;
      }

      setW(wNew);
      setResizeW({ movement: event.clientX, direction: resizeW.direction });

      return;
    }

    const wNew = w + resizeW.movement - event.clientX;
    if (wNew <= minWidth) {
      resetResize();
      resetMovement();
      return;
    }

    setW(wNew);
    setL(l + event.clientX - resizeW.movement);

    setResizeW({ movement: event.clientX, direction: resizeW.direction });
    setStartL(event.clientX);
  };

  const resolveResizeH = (event: MouseEvent<HTMLElement>) => {
    if (!resizeH) return;

    if (resizeH.direction === 1) {
      const hNew = h + event.clientY - resizeH.movement;
      if (hNew <= minHeight) return;

      setH(hNew);
      setResizeH({ movement: event.clientY, direction: resizeH.direction });

      return;
    }

    const hNew = h + resizeH.movement - event.clientY;
    if (hNew <= minHeight) return;

    setH(hNew);
    setT(t + event.clientY - resizeH.movement);

    setResizeH({ movement: event.clientY, direction: resizeH.direction });
    setStartT(event.clientY);
  };

  return { resolveResizeW, resolveResizeH, resolveMovement };
};
